import React from 'react';
import Link from '@material-ui/core/Link';
import { useStyles } from './TakisFooter.styles';
import TakisLink from '../components/TakisLink';
import { TakisSvg } from '../components/TakisSvgs';
import takiImage from '../assets/images/taki.png';
import nutImage from '../assets/images/nut.png';
import limeImage from '../assets/images/lime.png';
import { useLanguage, supportedLanguages } from '../hooks/useLanguage';

const Footer = ({data}) => {
    const classes = useStyles();
    const language = useLanguage();
    const isSpanish = language === supportedLanguages.es;
    const openNewTab = isSpanish ? "(abre en una nueva ventana)" : "(opens in new window)";

    return (
        <footer className={classes.footer}>
            <div className={classes.footerImages}>
                {takiImage && <img className={classes.footerImagesTaki} src={takiImage} alt="" loading="lazy"></img>}
                {nutImage && <img className={classes.footerImagesNut} src={nutImage} alt="" loading="lazy"></img>}
                {limeImage && <img className={classes.footerImagesLime} src={limeImage} alt="" loading="lazy"></img>}
            </div>
            <div className={classes.footerContent}>
                <ul className={classes.socialIconsList}>
                    {data.social_media.map((item) => {
                        return (
                          <li
                            className={classes.socialIconsListItem}
                            key={"social-icon_" + item.title}
                            >
                            <Link
                            key={item.id}
                            href={item.href}
                            target={item.target}
                            title={item.title}
                            aria-label={item.target == "_blank" ? `${item.title} ${openNewTab}` : item.title}
                            rel="noopener"
                            className={classes.socialIcons}>
                                {(() => {
                                    switch (item.title) {
                                    case "Facebook":
                                      return (
                                        <TakisSvg
                                            icon="facebook"
                                            ariaLabel={item.title}
                                            svg_class={classes.svg}
                                            viewbox="0 0 32 32"/>
                                        );
                                    case "Instagram":
                                      return (
                                        <TakisSvg
                                            icon="instagram"
                                            ariaLabel={item.title}
                                            svg_class={classes.svg}
                                            viewbox="0 0 32 32"/>
                                        );
                                    case "Twitter":
                                      return (
                                        <TakisSvg
                                            icon="twitter"
                                            ariaLabel={item.title}
                                            svg_class={classes.svg}
                                            viewbox="0 0 32 32" />
                                        );
                                    case "YouTube":
                                      return (
                                        <TakisSvg
                                            icon="youtube"
                                            ariaLabel={item.title}
                                            svg_class={classes.svg}
                                            viewbox="0 0 32 32" />
                                        );
                                    case "TikTok":
                                      return (
                                        <TakisSvg
                                            icon="tiktok"
                                            ariaLabel={item.title}
                                            svg_class={classes.svg}
                                            viewbox="0 0 32 32" />
                                        );
                                    default:
                                      return (
                                        <TakisSvg
                                            icon="facebook"
                                            aria-label={item.title}
                                            svg_class={classes.svg}
                                            viewbox="0 0 32 32"/>
                                        );
                                    }
                                })()}
                            </Link>
                          </li>
                        );
                    })}
                </ul>
                <div className={classes.generalLinksContainer}>
                    <ul className={classes.generalLinkslist}>
                        {data.legal.map((item) => {
                            return (
                                <li key={item.id} className={classes.generallinks}>
                                    <TakisLink href={item.href} target={item.target} title={item.title} ariaDescription={item.target == "_blank" ? openNewTab : ""} type={item.type} />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </footer>
    );

};

export default Footer;
